export const OTC365VNDBanks = [
    { value: 'Techcombank', label: 'Techcombank' },
    { value: 'Sacombank', label: 'Sacombank' },
    { value: 'Vietcombank', label: 'Vietcombank' },
    { value: 'Asia Commercial Bank', label: 'Asia Commercial Bank' },
    { value: 'DongA Bank', label: 'DongA Bank' },
    { value: 'Vietin Bank', label: 'Vietin Bank' },
    { value: 'Bank for Investment and Development of Vietnam', label: 'Bank for Investment and Development of Vietnam' },
    { value: 'Eximbank Vietnam', label: 'Eximbank Vietnam' },
    { value: 'Bank Rakyat Indonesia', label: 'Bank Rakyat Indonesia' },
    { value: 'Mandiri Bank', label: 'Mandiri Bank' },
    { value: 'CIMB Niaga', label: 'CIMB Niaga' },
    { value: 'Vietnam Prosperity Joint-Stock Commercial Bank', label: 'Vietnam Prosperity Joint-Stock Commercial Bank' },
    { value: 'Military Commercial Joint Stock Bank', label: 'Military Commercial Joint Stock Bank' },
    { value: 'Tien Phong Commercial', label: 'Tien Phong Commercial' },
    { value: 'AGRI BANK', label: 'AGRI BANK' },
    { value: 'Lien Viet Post Joint Stock Commercial Bank', label: 'Lien Viet Post Joint Stock Commercial Bank' },
    { value: 'Saigon – Hanoi Commercial Joint Stock Bank', label: 'Saigon – Hanoi Commercial Joint Stock Bank' },
    { value: 'Vietnam Public Joint-stock Commercial Bank', label: 'Vietnam Public Joint-stock Commercial Bank' },
    { value: 'SAIGON BANK', label: 'SAIGON BANK' },
    { value: 'Southeast Asia Commercial Joint Stock Bank', label: 'Southeast Asia Commercial Joint Stock Bank' },
    { value: 'An Binh Commercial Join Stock Bank', label: 'An Binh Commercial Join Stock Bank' },
    { value: 'Bac A Bank', label: 'Bac A Bank' },
    { value: 'Viet Capital Bank', label: 'Viet Capital Bank' },
    { value: 'Vietnam Maritime Commercial Joint Stock Bank', label: 'Vietnam Maritime Commercial Joint Stock Bank' },
    { value: 'Kien Long Commercial Joint Stock Bank', label: 'Kien Long Commercial Joint Stock Bank' },
    { value: 'Nam A Commercial Joint Stock Bank', label: 'Nam A Commercial Joint Stock Bank' },
    { value: 'National Citizen Commercial Joint Stock Bank', label: 'National Citizen Commercial Joint Stock Bank' },
    { value: 'HD Bank', label: 'HD Bank' },
    { value: 'Orient Commercial Joint Stock Bank', label: 'Orient Commercial Joint Stock Bank' },
    {
        value: 'Vietnam International Commercial Joint Stock Bank',
        label: 'Vietnam International Commercial Joint Stock Bank',
    },
    { value: 'Sai Gon Joint Stock Commercial Bank', label: 'Sai Gon Joint Stock Commercial Bank' },
    { value: 'Saigon Bank for Industry and Trade', label: 'Saigon Bank for Industry and Trade' },
    { value: 'VietABank', label: 'VietABank' },
    { value: 'BAOVIET Bank', label: 'BAOVIET Bank' },
    { value: 'Vietnam Thuong Tin Commercial Joint Stock Bank', label: 'Vietnam Thuong Tin Commercial Joint Stock Bank' },
    { value: 'Petrolimex Group Commercial Joint Stock Bank', label: 'Petrolimex Group Commercial Joint Stock Bank' },
    { value: 'Others Bank', label: 'Others Bank' },
].reduce((obj, kv) => ({ ...obj, [kv.value]: { key: kv.value, ...kv } }), {});
